'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwImage = require('../cwimage/CwImage');

var _CwImage2 = _interopRequireDefault(_CwImage);

var _CwPill = require('./CwPill.scss');

var _CwPill2 = _interopRequireDefault(_CwPill);

var _IconPath = require('../../utils/IconPath');

var _IconPath2 = _interopRequireDefault(_IconPath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @type {React.StatelessComponent} */
var CwPill = function CwPill(_ref) {
  var id = _ref.id,
      value = _ref.value,
      _ref$deletePillIcon = _ref.deletePillIcon,
      deletePillIcon = _ref$deletePillIcon === undefined ? null : _ref$deletePillIcon,
      _ref$onDeletePill = _ref.onDeletePill,
      onDeletePill = _ref$onDeletePill === undefined ? null : _ref$onDeletePill;

  return _react2.default.createElement(
    'span',
    {
      className: _CwPill2.default.pill,
      key: id
    },
    value,
    onDeletePill ? _react2.default.createElement(_CwImage2.default, {
      onClick: function onClick() {
        onDeletePill({ id: id, value: value });
      },
      className: _CwPill2.default.closeIcon,
      isInlineSVG: false,
      src: deletePillIcon }) : null
  );
};

CwPill.propTypes = {
  /**
   * The key to be used for this pill
   */
  id: _propTypes2.default.any.isRequired,
  /**
   * The value to display on the pill
   */
  value: _propTypes2.default.string.isRequired,
  /**
  * The icon to display on the pill
  */
  deletePillIcon: _propTypes2.default.string,
  /**
  * The function to be called when the pill is closed
  */
  onDeletePill: _propTypes2.default.func
};

CwPill.defaultProps = {
  deletePillIcon: _IconPath2.default.get('Action_Close')
};

exports.default = CwPill;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwpill/CwPill.js
// module id = 374
// module chunks = 10